<template>
  <div></div>
</template>

<script>
import ThemeService from '@/services/themeService';

export default {
  name: 'EcsTheme',

  created() {
    this.$vuetify.theme.themes = ThemeService.getDefault();
    this.$vuetify.theme.dark = true;
  }
};
</script>
